import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

const PER_PAGE_DEFAULT = 3;
const GAP_DEFAULT = 0;

export default class SliderCarousel extends HTMLElement {
  constructor() {
    super();

    // Attach shadow DOM
    this.attachShadow({ mode: 'open' });

    // Define shadow DOM template
    this.shadowRoot.innerHTML = `
    <style>
      :host{
        display: flex;
      }
      .splide__container{box-sizing:border-box;position:relative}.splide__list{backface-visibility:hidden;display:-ms-flexbox;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{display:none}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{backface-visibility:hidden;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__arrow{-ms-flex-align:center;align-items:center;background:#ccc;border:0;border-radius:50%;cursor:pointer;display:-ms-flexbox;display:flex;height:2em;-ms-flex-pack:center;justify-content:center;opacity:.7;padding:0;position:absolute;top:50%;transform:translateY(-50%);width:2em;z-index:1}.splide__arrow svg{fill:#000;height:1.2em;width:1.2em}.splide__arrow:hover:not(:disabled){opacity:.9}.splide__arrow:disabled{opacity:.3}.splide__arrow:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide__arrow--prev{left:1em}.splide__arrow--prev svg{transform:scaleX(-1)}.splide__arrow--next{right:1em}.splide.is-focus-in .splide__arrow:focus{outline:3px solid #0bf;outline-offset:3px}.splide__pagination{bottom:.5em;left:0;padding:0 1em;position:absolute;right:0;z-index:1}.splide__pagination__page{background:#ccc;border:0;border-radius:50%;display:inline-block;height:8px;margin:3px;opacity:.7;padding:0;position:relative;transition:transform .2s linear;width:8px}.splide__pagination__page.is-active{background:#fff;transform:scale(1.4);z-index:1}.splide__pagination__page:hover{cursor:pointer;opacity:.9}.splide__pagination__page:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__pagination__page:focus{outline:3px solid #0bf;outline-offset:3px}.splide__progress__bar{background:#ccc;height:3px}.splide__slide{-webkit-tap-highlight-color:rgba(0,0,0,0)}.splide__slide:focus{outline:0}@supports(outline-offset:-3px){.splide__slide:focus-visible{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide__slide:focus-visible{border:3px solid #0bf}}@supports(outline-offset:-3px){.splide.is-focus-in .splide__slide:focus{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide.is-focus-in .splide__slide:focus{border:3px solid #0bf}.splide.is-focus-in .splide__track>.splide__list>.splide__slide:focus{border-color:#0bf}}.splide__toggle{cursor:pointer}.splide__toggle:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__toggle:focus{outline:3px solid #0bf;outline-offset:3px}.splide__track--nav>.splide__list>.splide__slide{border:3px solid transparent;cursor:pointer}.splide__track--nav>.splide__list>.splide__slide.is-active{border:3px solid #000}.splide__arrows--rtl .splide__arrow--prev{left:auto;right:1em}.splide__arrows--rtl .splide__arrow--prev svg{transform:scaleX(1)}.splide__arrows--rtl .splide__arrow--next{left:1em;right:auto}.splide__arrows--rtl .splide__arrow--next svg{transform:scaleX(-1)}.splide__arrows--ttb .splide__arrow{left:50%;transform:translate(-50%)}.splide__arrows--ttb .splide__arrow--prev{top:1em}.splide__arrows--ttb .splide__arrow--prev svg{transform:rotate(-90deg)}.splide__arrows--ttb .splide__arrow--next{bottom:1em;top:auto}.splide__arrows--ttb .splide__arrow--next svg{transform:rotate(90deg)}.splide__pagination--ttb{bottom:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;left:auto;padding:1em 0;right:.5em;top:0}

      ${
        this.hideThumbnails
          ? `
        .splide__arrow {
          background: white;
          border: 1px solid #E1CCAD;
          opacity: 1;
          top: 35%;
        }
        .splide__arrow {
          width: 35px;
          height: 35px;
        }
        .splide__arrow:disabled {
          display: none;
        }
        .splide__arrow svg {
          fill: #E1CCAD;
        }
        .splide__arrow--prev {
          left: ${this.arrowsPosition};
        }
        .splide__arrow--next {
          right: ${this.arrowsPosition};
        }
        @media (max-width: 990px) {
          .splide__arrow--prev {
            left: ${this.arrowsPositionMobile};
          }
          .splide__arrow--next {
            right: ${this.arrowsPositionMobile};
          }
        }
      `
          : `
        .splide__arrow {
          background: transparent;
          opacity: 1;
        }
        .splide__arrow svg {
          width: 30px;
          height: 30px;
        }`
      }

      .splide__slide {
        display: flex;
        justify-content: center;
      }
      .thumbnail-slider .splide__arrow svg {
        width: 14px;
        height: 14px;
      }
      .thumbnail-slider {
        margin-right: 26px;
      }
      .thumbnail-slider .splide__slide img {
        width: 91px;
        height: 91px;
      }
      .thumbnail-slider .splide__track {
        top: 55px
      }
      .thumbnail-slider .splide__track--nav>.splide__list>.splide__slide.is-active {
          border: 2px solid #d2eae5;
      }
      .main-slider {
        width: 100%;
        max-width: 1440px;
      }

      .slide-wrapper {
        overflow: hidden;
        border-radius: 12px;
        border: 1px solid #e9dfd7;
        height: 398px;
        display: block;
        cursor: pointer;
        text-decoration: none;
        color: black;
      }
      .slide-wrapper .slide-image {
        background-color: #FBF5F0;
        text-align: center;
      }
      .slide-wrapper .slide-image img{
        width: 90%;
      }
      .slide-description {
        padding: 10px 20px;
        text-align: center;
      }
      .slide-description h3 {
        font-weight: normal;
        font-size: 22px;
        line-height: 30px;
        margin: 10px 0;
      }
      .slide-description p {
        font-size: 14px
      }

      @media (max-width: 990px) {
        .slide-description h3 {
          font-size: 16px;
          line-height: 22px;
        }
        .slide-wrapper .slide-image img{
          width: 100%;
        }
        .slide-wrapper {
          height: auto;
          min-height: 323px;
        }
        .splide__track {
          max-height: unset;
          height: inherit !important;
        }
        .splide__list, .splide__slide {
          max-height: unset;
          height: inherit !important;
        }
      }

      @media (max-width: 640px) {
        :host {
          flex-direction:column;
        }
        .main-slider {
          width: 90vw;
          order: -1;
        }
        .thumbnail-slider {
          margin-right: 0;
          margin-top: 20px;
          display: none;
        }
        .thumbnail-slider .splide__track {
          top: 0;
          width: 80%;
          margin: 0 auto;
        }
      }
    </style>

    ${
      !this.hideThumbnails
        ? `<div class="thumbnail-slider splide">
          <div class="splide__track">
            <ul class="splide__list">
              <!-- Thumbnails will go here -->
            </ul>
          </div>
        </div>`
        : ''
    }
    <section class="main-slider splide">
      <div class="splide__track">
        <ul class="splide__list">
        </ul>
      </div>
    </section>
    `;
  }

  connectedCallback() {
    const slot = document.createElement('slot');
    this.shadowRoot
      .querySelector('.main-slider .splide__list')
      .appendChild(slot);

    slot.addEventListener('slotchange', () => {
      const assignedElements = slot.assignedNodes({ flatten: true });
      const mainList = this.shadowRoot.querySelector(
        '.main-slider .splide__list'
      );

      let thumbnailList;
      if (!this.hideThumbnails) {
        thumbnailList = this.shadowRoot.querySelector(
          '.thumbnail-slider .splide__list'
        );
      }

      assignedElements.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Wrap each child for main slider
          const mainSlide = document.createElement('li');
          mainSlide.classList.add('splide__slide');
          mainSlide.appendChild(node.cloneNode(true)); // Clone for main slider
          if (this.hideThumbnails) {
            node.remove();
          } else {
            mainSlide.querySelector('img').style.width = '100%';
          }
          mainList.appendChild(mainSlide);

          if (!this.hideThumbnails) {
            // Create corresponding thumbnail slide
            const thumbnailSlide = document.createElement('li');
            thumbnailSlide.classList.add('splide__slide');
            const thumbnailContent = node.cloneNode(true);
            thumbnailSlide.appendChild(thumbnailContent);
            //thumbnailSlide.querySelector('img').style.width = '70px';
            thumbnailList.appendChild(thumbnailSlide);
          }
        }
      });

      // Initialize both Splide sliders
      this.initializeSplides();
    });
  }

  initializeSplides() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const isSosBundleCollection = window.location.href.includes(
      'collections/hair-repair-trio'
    );

    const objectSlider = () => {
      if (this.hideThumbnails) {
        return {
          pagination: false,
          arrows: true,
          drag: 'free',
          perPage: isMobile ? this.perPageMobile : this.perPage,
          gap: this.gap
        };
      } else if (isMobile) {
        return {
          heightRatio: 1,
          pagination: true,
          arrows: false,
          drag: 'free'
        };
      } else {
        return {
          heightRatio: 1,
          pagination: false,
          arrows: true,
          drag: 'free'
        };
      }
    };

    this.mainSplide = new Splide(
      this.shadowRoot.querySelector('.main-slider'),
      objectSlider()
    );

    if (isMobile || this.hideThumbnails) {
      this.mainSplide.mount();
    } else {
      this.thumbnailSplide = new Splide(
        this.shadowRoot.querySelector('.thumbnail-slider'),
        {
          fixedWidth: 95,
          fixedHeight: 95,
          isNavigation: true,
          gap: 10,
          focus: 'center',
          pagination: false,
          cover: true,
          direction: 'ttb',
          height: '450px',
          breakpoints: {
            640: {
              direction: 'ltr'
            }
          }
        }
      );

      // Sync the thumbnail slider with the main slider
      this.mainSplide.sync(this.thumbnailSplide);
      this.mainSplide.mount();
      this.thumbnailSplide.mount();
    }
  }

  disconnectedCallback() {
    if (this.mainSplide) {
      this.mainSplide.destroy();
    }
    if (this.thumbnailSplide) {
      this.thumbnailSplide.destroy();
    }
  }

  get isThumbnail() {
    return this.getAttribute('thumbnail') === 'true';
  }

  get firstSlideImage() {
    return this.shadowRoot.querySelector('.main-slider .image-slide img');
  }

  get perPage() {
    return parseInt(this.getAttribute('per-page')) || PER_PAGE_DEFAULT;
  }

  get perPageMobile() {
    return parseInt(this.getAttribute('per-page-mobile')) || this.perPage;
  }

  get gap() {
    return parseInt(this.getAttribute('gap')) || GAP_DEFAULT;
  }

  get arrowsPosition() {
    return this.getAttribute('arrows-position') || '0';
  }

  get arrowsPositionMobile() {
    return this.getAttribute('arrows-position-mobile') || '0';
  }

  get hideThumbnails() {
    return (
      this.getAttribute('hide-thumbnails') === 'true' ||
      this.getAttribute('hide-thumbnails') === ''
    );
  }

  set hideThumbnails(value) {
    this.setAttribute('hide-thumbnails', `${value}`);
  }
}
